<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <BaseLoading  opaque :spinning="athleteLoading">
      <div class="container">
        <div class="steps-content">
          <div class="general-form-wrap player-detail-form-wrap box-wrapper">
            <div class="heading">
              <h2 class="form-title">Players Details</h2>
            </div>
            <div class="player-form-wrap">
              <FormModel
                layout="horizontal"
                :form="form"
                @submit="handleSubmit"
                ref="form"
                :model="resource"
                :rules="validationRules"
              >
                <a-row :gutter="32">
                  <a-col :sm="24" :md="10">
                    <a-row :gutter="16">
                      <a-col :sm="12">
                        <BaseSelect
                          name="playingSince"
                          labelPath="label"
                          valuePath="value"
                          label="Playing Since"
                          placeholder="Playing Since"
                          :items="yearsArray"
                          :value="resource.playingSince || undefined"
                          @change="
                            value => handleFormItemChange('playingSince', value)
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseTaxonomySelect
                          resource="battingHand"
                          type="Bats"
                          name="battingHandId"
                          placeholder="Batting Hand"
                          label="Batting Hand"
                          :value="resource.battingHandId || undefined"
                          @change="
                            value =>
                              handleFormItemChange('battingHandId', value)
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseFormInput
                          name="battingAverage"
                          label="Batting Average(ex .350)"
                          placeholder="Batting Average"
                          :value="resource.battingAverage || undefined"
                          type="text"
                          @change="
                            event =>
                              handleFormItemChange(
                                'battingAverage',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseTaxonomySelect
                          resource="throwingHand"
                          type="Throws"
                          name="throwingHandId"
                          placeholder="Throwing Hand"
                          label="Throwing Hand"
                          :value="resource.throwingHandId || undefined"
                          @change="
                            value =>
                              handleFormItemChange('throwingHandId', value)
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseSelect
                          name="graduationYear"
                          labelPath="label"
                          valuePath="value"
                          label="Graduation Year"
                          placeholder="Graduation Year"
                          :value="resource.graduationYear || undefined"
                          :items="graduationYears"
                          @change="
                            value =>
                              handleFormItemChange('graduationYear', value)
                          "
                        />
                      </a-col>
                      <a-col
                        :sm="12"
                        v-if="resource.graduationYear === 'College Transfer'"
                      >
                        <BaseSelect
                          name="remainingYears"
                          labelPath="label"
                          valuePath="value"
                          label="Remaning Year"
                          :value="resource.remainingYears"
                          :items="yearsRemaining"
                          @change="
                            value =>
                              handleFormItemChange('remainingYears', value)
                          "
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :sm="24" :md="8">
                    <a-row :gutter="16">
                      <a-col :sm="24">
                        <BaseTaxonomySelect
                          resource="playerPosition"
                          type="Player Position"
                          placeholder="Preferred Position"
                          mode="multiple"
                          name="positionIds"
                          label="Preferred Position"
                          :value="resource.positionIds"
                          @change="
                            value => handleFormItemChange('positionIds', value)
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseSelect
                          name="firstToHomeTime"
                          placeholder="Home to 1st"
                          label="Home to 1st"
                          :humanize-label="false"
                          allow-clear
                          :items="homeTofirstTime"
                          :value="resource.firstToHomeTime"
                          @change="
                            value =>
                              handleFormItemChange('firstToHomeTime', value)
                          "
                        />
                      </a-col>
                      <a-col :sm="12">
                        <BaseSelect
                          name="secondToHomeTime"
                          placeholder=" 2nd to Home"
                          label="2nd to Home"
                          allow-clear
                          :humanize-label="false"
                          :items="hometoSecondTime"
                          :value="resource.secondToHomeTime"
                          @change="
                            value =>
                              handleFormItemChange('secondToHomeTime', value)
                          "
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :sm="24" :md="6">
                    <div class="head-title">Commited to a College?</div>
                    <a-radio-group
                      :value="resource.committed"
                      @change="
                        event =>
                          handleFormItemChange('committed', event.target.value)
                      "
                    >
                      <a-radio :value="true">Yes</a-radio>
                      <a-radio :value="false">No</a-radio>
                    </a-radio-group>
                  </a-col>
                  <div class="academic-info ">
                    <div class="heading padding-top-1">
                      <h2 class="form-title">Social Media Links</h2>
                    </div>
                    <a-row :gutter="32">
                      <a-col :sm="8">
                        <BaseFormInput
                          name="Facebook"
                          placeholder="Enter Facebook Link"
                          label="Facebook"
                          :value="resource.facebook"
                          @change="
                            event =>
                              handleFormItemChange(
                                'facebook',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="twitter"
                          placeholder="Enter Twitter Link"
                          label="Twitter"
                          :value="resource.twitter"
                          @change="
                            event =>
                              handleFormItemChange(
                                'twitter',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="Instagram"
                          placeholder="Enter Instagram Link"
                          label="Instagram"
                          :value="resource.instagram"
                          @change="
                            event =>
                              handleFormItemChange(
                                'instagram',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="Linkedin"
                          placeholder="Enter Linkedin Link"
                          label="Linkedin"
                          :value="resource.linkedin"
                          @change="
                            event =>
                              handleFormItemChange(
                                'linkedin',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="podcast"
                          placeholder="Enter Podcast Link"
                          label="Podcast"
                          :value="resource.podcast"
                          @change="
                            event =>
                              handleFormItemChange(
                                'podcast',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="youtube"
                          placeholder="Enter youtube Link"
                          label="Youtube"
                          :value="resource.youtube"
                          @change="
                            event =>
                              handleFormItemChange(
                                'youtube',
                                event.target.value
                              )
                          "
                        />
                      </a-col>
                      <a-col :sm="8">
                        <BaseFormInput
                          name="flickr"
                          placeholder="Enter flickr Link"
                          label="Flickr"
                          :value="resource.flickr"
                          @change="
                            event =>
                              handleFormItemChange('flickr', event.target.value)
                          "
                        />
                      </a-col>
                    </a-row>
                  </div>
                </a-row>
                <a-row>
                  <div class="heading margin-top-1">
                    <h2 class="form-title">Bio</h2>
                  </div>
                  <div class="player-form-wrap">
                    <div class="label-text">Your Information:</div>
                    <a-textarea
                      name="bio"
                      placeholder="Enter Your Information"
                      label="Enter Your Information"
                      type="text"
                      class="custom-height"
                      :value="resource.bio"
                      @change="
                        event => handleFormItemChange('bio', event.target.value)
                      "
                    />
                  </div>
                </a-row>
                <a-form-item>
                  <a-button
                    type="primary"
                    html-type="submit"
                    class="next-button"
                    >Save</a-button
                  >
                </a-form-item>
              </FormModel>
            </div>
          </div>
        </div>
      </div>
    </BaseLoading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Athlete } from "@/models";
import { FormModel } from "ant-design-vue";

import { RepositoryFactory } from "../../../../../repositories/RepositoryFactory";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");

const STORE_KEY = "athleteStore";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "PlayerDetails",
  data() {
    return {
      resource: new Athlete({}),
      value: 2,
      yearsArray: [],
      currentYear: "",
      validationRules: Athlete.detailsValidationRules,
      playingSinceArray: [],
      homeTofirstTime: Athlete.homeTo1stData,
      hometoSecondTime: Athlete.homeTo2ndData,
      yearsRemaining: [
        { label: "1 year", value: "1 year" },
        { label: "2 years", value: "2 years" },
        { label: "3 years", value: "3 years" },
        { label: "4 years", value: "4 years" }
      ],
      graduationYearArray: [
        { label: "College Transfer", value: "College Transfer" }
      ],
      taxonomyvalues: [
        {
          name: "position",
          taxValue: "Player Position"
        },
        {
          name: "battingHand",
          taxValue: "Bats"
        },
        {
          name: "throwingHand",
          taxValue: "Throws"
        }
      ],
      playerInfo: {
        isYearRemaining: false,
        playingSince: [],
        battingHand: [],
        throwingHand: [],
        graduationYear: ["College Transfer"],
        position: []
      },
      stateList: [],
      collegeList: [],
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.dispatcher();
    this.playingSince();
  },
  components: {
    FormModel
  },
  created() {
    for (let i = 0; i < this.taxonomyvalues.length; i++) {
      TaxonomyRepository.getTaxonomyValues(
        this.taxonomyvalues[i].taxValue
      ).then(response => {
        this.playerInfo[this.taxonomyvalues[i].name] =
          response.data.taxonomy.values;
      });
    }
    let today = new Date();
    let year = today.getFullYear();
    for (let i = year; i < year + 11; i++) {
      this.playerInfo.graduationYear.push(i);
    }
    for (let i = year; i >= year - 16; i--) {
      this.playerInfo.playingSince.push(i);
    }
  },
  computed: {
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${STORE_KEY}/athlete`,
      athleteLoading: `${STORE_KEY}/athleteLoading`
    }),
    athleteId() {
      return this.id || this.$route.params.profileId;
    },
    graduationYears() {
      return Athlete.graduationConfig();
    }
  },
  methods: {
    handleFormItemChange(key, value) {
      this.resource = new Athlete({ ...this.resource, [key]: value });
    },
    async dispatcher() {
      await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
        id: this.athleteId
      });
    },
    playingSince() {
      for (let i = 0; i < 21; i++) {
        let currentYear = new Date().getFullYear();
        this.yearsArray = [...this.yearsArray, currentYear - i];
      }
    },
    ...mapActions({
      setPlayerDetailInfo: `${STORE_KEY}/setPlayerDetailInfo`
    }),

    onRadioChange(e) {
      this.value = e.target.value;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },

    // Submit value
    handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("logo", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(`${STORE_KEY}/updateAthleteImage`, {
              id: this.athleteId,
              image: formData
            }));
          const params = {
            id: this.athleteId,
            slug: "athlete",
            playingSince: this.resource.playingSince,
            position: this.resource.positionIds,
            battingHand: this.resource.battingHandId,
            battingAverage: this.resource.battingAverage,
            throwingHand: this.resource.throwingHandId,
            committed: this.resource.committed,
            firstToHomeTime: this.resource.firstToHomeTime,
            graduationYear: this.resource.graduationYear,
            secondToHomeTime: this.resource.secondToHomeTime,
            facebook: this.resource.facebook,
            instagram: this.resource.instagram,
            twitter: this.resource.twitter,
            flickr: this.resource.flickr,
            youtube: this.resource.youtube,
            podcast: this.resource.podcast,
            linkedin: this.resource.linkedin,
            bio: this.resource.bio,
            remainingYears:
              this.resource.graduationYear === "College Transfer"
                ? this.resource.remainingYears
                : "",
            message: "Player Details Updated"
          };
          await this.$store.dispatch(`${STORE_KEY}/updateAthlete`, params);
          await this.$store.dispatch(`${STORE_KEY}/getAthlete`, {
            id: this.athleteId
          });
        }
      });
    }
  },
  watch: {
    athlete(newVal, _) {
      this.resource = new Athlete(newVal);
      let today = new Date();
      let year = today.getFullYear();
      for (let i = year; i < year + 11; i++) {
        this.graduationYearArray.push({ label: i, value: i });
      }
      for (let i = year; i >= year - 16; i--) {
        this.playingSinceArray.push({ label: i, value: i });
      }
    }
  }
};
</script>
<style lang="scss"></style>
